import React from 'react';
import { useTranslation } from 'react-i18next';

import { LayoutList, List } from 'lucide-react';
import { isSaudiBrand } from '../../../products/saudi/utils/isSaudiBrand';

/**
 * Bascule vue tableau / cartes — mode clair : segment bleu plein (lisible) ;
 * mode sombre : glass bleu existant.
 * Qawaem : style Console (vert forêt).
 */
export default function FacturationViewModeToggle({
  viewMode,
  onViewModeChange,
  isLight,
  CardsIcon = LayoutList,
  cardsTitle,
  tableTitle,
}) {
  const { t } = useTranslation();
  const qawaem = isSaudiBrand();
  const p = (key) => t(`modules.facturation.pages.facturationViewModeToggle.${key}`);
  const resolvedCardsTitle = cardsTitle ?? p('view_cards');
  const resolvedTableTitle = tableTitle ?? p('view_table');

  if (qawaem || isLight) {
    const active = 'bg-[#6e9b6e]/15 text-[#5a855a]';
    const idle = 'text-console-muted hover:bg-[#6e9b6e]/5';
    return (
      <div className="facturation-view-mode-toggle flex shrink-0 items-center gap-0">
        <div className="inline-flex h-[38px] items-center overflow-hidden rounded-lg border border-[#6e9b6e]/15">
          <button
            type="button"
            onClick={() => onViewModeChange('cards')}
            className={`h-full px-2.5 flex items-center justify-center transition-colors border-e border-[#6e9b6e]/12 ${
              viewMode === 'cards' ? active : idle
            }`}
            title={resolvedCardsTitle}
          >
            <CardsIcon size={17} strokeWidth={viewMode === 'cards' ? 2.25 : 2} className="shrink-0" />
          </button>
          <button
            type="button"
            onClick={() => onViewModeChange('table')}
            className={`h-full px-2.5 flex items-center justify-center transition-colors ${
              viewMode === 'table' ? active : idle
            }`}
            title={resolvedTableTitle}
          >
            <List size={17} strokeWidth={viewMode === 'table' ? 2.25 : 2} className="shrink-0" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="facturation-view-mode-toggle flex shrink-0 items-center gap-0">
      {isLight ? (
        <div className="inline-flex rounded-lg border border-slate-300 bg-slate-50/90 p-0.5 shadow-sm">
          <button
            type="button"
            onClick={() => onViewModeChange('cards')}
            className={`flex h-6 w-6 flex-none items-center justify-center rounded-md px-0 py-0 transition-all sm:h-auto sm:w-auto sm:px-3 sm:py-2 ${
              viewMode === 'cards'
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-slate-600 hover:bg-white'
            }`}
            title={resolvedCardsTitle}
          >
            <CardsIcon size={18} strokeWidth={viewMode === 'cards' ? 2.25 : 2} className="shrink-0" />
          </button>
          <button
            type="button"
            onClick={() => onViewModeChange('table')}
            className={`flex h-6 w-6 flex-none items-center justify-center rounded-md px-0 py-0 transition-all sm:h-auto sm:w-auto sm:px-3 sm:py-2 ${
              viewMode === 'table'
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-slate-600 hover:bg-white'
            }`}
            title={resolvedTableTitle}
          >
            <List size={18} strokeWidth={viewMode === 'table' ? 2.25 : 2} className="shrink-0" />
          </button>
        </div>
      ) : (
        <div className="inline-flex overflow-hidden rounded-md border border-white/20">
          <button
            type="button"
            onClick={() => onViewModeChange('cards')}
            className={`flex h-6 w-6 flex-none items-center justify-center border-0 px-0 py-0 transition-all sm:h-auto sm:w-auto sm:px-3 sm:py-2 ${
              viewMode === 'cards'
                ? 'bg-blue-500/20 text-blue-300'
                : 'bg-white/5 text-white hover:bg-white/10'
            } border-r border-white/15`}
            title={resolvedCardsTitle}
          >
            <CardsIcon size={18} className="shrink-0" />
          </button>
          <button
            type="button"
            onClick={() => onViewModeChange('table')}
            className={`flex h-6 w-6 flex-none items-center justify-center border-0 px-0 py-0 transition-all sm:h-auto sm:w-auto sm:px-3 sm:py-2 ${
              viewMode === 'table'
                ? 'bg-blue-500/20 text-blue-300'
                : 'bg-white/5 text-white hover:bg-white/10'
            }`}
            title={resolvedTableTitle}
          >
            <List size={18} className="shrink-0" />
          </button>
        </div>
      )}
    </div>
  );
}
